import type { StatusData } from './types';

const STATUS_FILE_URL = 'https://storage.googleapis.com/accorded-status-page/status.json';

export async function fetchStatusData(): Promise<StatusData> {
  // In development or if fetch fails, use mock data
  if (process.env.NODE_ENV === 'development') {
    console.log('Using mock data in development mode');
    return mockData;
  }

  try {
    const response = await fetch(STATUS_FILE_URL);
    if (!response.ok) {
      throw new Error(`Failed to fetch status data: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching status data:', error);
    // Fallback to mock data in case of errors
    return mockData;
  }
}

// Mock data for development and fallback
const mockData: StatusData = {
  lastUpdated: '2025-01-03T12:00:00Z',
  maintenance: {
    startTime: '2025-01-15T02:00:00Z',
    endTime: '2025-01-15T04:00:00Z',
    message: 'Scheduled database maintenance'
  },
  incidentHistory: {
    lookbackMonths: 1,
    incidents: [
      {
        id: 'INC-2024-001',
        title: 'Data Transfer Service Degradation',
        status: 'resolved',
        severity: 'major',
        startTime: '2024-12-15T01:23:00Z',
        endTime: '2024-12-15T04:56:00Z',
        affectedSystems: ['SFTP', 'Snowflake'],
        updates: [
          {
            timestamp: '2024-12-15T01:23:00Z',
            message: 'Investigating reports of slow data transfers',
            status: 'investigating'
          },
          {
            timestamp: '2024-12-15T02:15:00Z',
            message: 'Identified network bottleneck causing delays',
            status: 'identified'
          },
          {
            timestamp: '2024-12-15T04:56:00Z',
            message: 'Network capacity increased, service restored to normal',
            status: 'resolved'
          }
        ]
      }
    ]
  },
  categories: [
    {
      name: 'Data Transfer',
      systems: [
        { name: 'SFTP', status: 'healthy', message: '' },
        { name: 'Snowflake', status: 'degraded', message: 'Minor lag' },
        { name: 'AWS', status: 'healthy', message: '' },
        { name: 'Other', status: 'failed', message: 'Outage reported' },
      ],
    },
    {
      name: 'Core Services',
      systems: [
        { name: 'Model Processing', status: 'healthy', message: '' },
        { name: 'Acumen Application', status: 'healthy', message: '' },
      ],
    }
  ]
};
